(function (app) {

    app.provider("arcEnrollmentsApi",
        [
            function () {
                this.$get = [
                    "complianceHubApiGateway", function (complianceHubApiGateway) {
                        var service = {};

                        service.getArcAgentEnrollments = function () {                         
                            return complianceHubApiGateway.get("/ArcEnrollments/");
                        };

                        service.getAllArcEnrollments = function () {
                            return complianceHubApiGateway.getArray("/ArcEnrollments/All");
                        };

                        service.isEnrolled = function (surveyId) {
                            return complianceHubApiGateway.get("/ArcEnrollments/" + surveyId + "/IsEnrolled");
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line